import React, { Component } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import {
  RetailPosModule,
  InventoryModule,
  PurchasesModule,
  OrdersManagementModule,
  DeliveryManagementModule,
  PackagingManagementModule,
  CrmModule,
  HrmModule,
  AccountingModule,
  ReportsModule,
  LeadsManagementModule,
  CouponsManagementModule,
  QuoteManagementModule,
  SalesOrderModule,
  DemoButton,
} from "./CommonModules";

import CartContext from "./CartContext";

// Reusable FeatureSection component

export class POS extends Component {
  static contextType = CartContext;

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleTryNow = () => {
    if (this.context.userData.loginStatus !== "active") {
      this.context.ShowUserLoginNew(true);
    }
    const product = this.context.prods.find(
      (f) => f.productType === this.context.ProductType.Retail_POS
    );
    if (product) {
      this.context.SetSelectedProduct(product);
    }
  };

  render() {
    if (this.context.EcSettings.length === 0) {
      return <></>;
    }
    return (
      <>
        {/* Hero Section */}
        <section className="container-fluid py-5 bg-white" id="posSection">
          <div className="container">
            <div className="row gx-5">
              <div className="col-12 border-start border-5 border-primary ps-3 mb-lg-5">
                <h6 className="text-primary text-uppercase">
                  Retail Billing Solution
                </h6>
                <Row>
                  <Col md={9}>
                    <h2 className="display-6 fw-bold">
                      {/* Retail Point-Of-Sale (POS) */}
                      {this.context.prods.filter(
                        (f) =>
                          f.productType === this.context.ProductType.Retail_POS
                      )[0]?.name || ""}
                    </h2>
                  </Col>
                  <Col className="text-end">
                    <Button
                      variant="warning"
                      className=""
                      as={Link}
                      to="/Checkout"
                      onClick={(e) =>
                        this.context.HandleTryNowButtonClick(
                          this.context.ProductType.Retail_POS
                        )
                      }
                    >
                      Try Free / Buy
                    </Button>
                    <DemoButton></DemoButton>
                  </Col>
                </Row>
              </div>
              <h5>
                {this.context.prods.filter(
                  (f) => f.productType === this.context.ProductType.Retail_POS
                )[0]?.description || ""}
              </h5>

              <div className="col-lg-12 mb-lg-5">
                <video
                  controls
                  height="400px"
                  autoPlay
                  muted
                  loop
                  width="100%"
                  // className="rounded shadow"
                  aria-label="POS software demo video"
                >
                  <source
                    src={
                      this.context.GetEcSettingValueByName(
                        "StorageBlobImageUrl"
                      ) + "RetailPosVideo.mp4"
                    }
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>

              <h4 className="display-6  mb-0">Features and Benefits</h4>
              <div className="col-lg-12">
                <div className="bg-light p-4 rounded shadow-sm">
                  <Row className="align-items-center mb-4">
                    <Col md={6}>
                      <Button
                        variant="warning"
                        className=""
                        as={Link}
                        to="/Checkout"
                        onClick={(e) =>
                          this.context.HandleTryNowButtonClick(
                            this.context.ProductType.Retail_POS
                          )
                        }
                      >
                        Try Free / Buy
                      </Button>
                    </Col>
                    <Col md={6} className="text-end"></Col>
                  </Row>

                  {/* POS Feature Sections */}

                  <Row className="align-items-center mb-4">
                    <Col md={6}>
                      <FeatureSection
                        title="🔒 Accessibility & Security"
                        items={[
                          "Use on any device: Phone, Tablet, or PC",
                          "Touch and keyboard-friendly interface",
                          "Responsive layout for all screen sizes",
                          "Secure 2-Factor Authentication login",
                        ]}
                      />

                      <FeatureSection
                        title="⚡ Fast & Efficient Billing"
                        items={[
                          "Quick paper or digital invoice generation",
                          "Supports multiple billing counters",
                          "Barcode and weighing machine compatible",
                          "AI-powered smart product search",
                        ]}
                      />

                      <FeatureSection
                        title="🎁 Promotions & Flexibility"
                        items={[
                          "Built-in support for coupons, discounts & loyalty points",
                          "Smooth return and refund workflows",
                          "Integrated tax and delivery charges",
                        ]}
                      />
                    </Col>
                    <Col md={6}>
                      <FeatureSection
                        title="💳 Payment Options"
                        items={[
                          "Accepts Cash, Card, UPI, QR Codes, COD, and Payment Gateways",
                        ]}
                      />

                      <FeatureSection
                        title="📦 Inventory & Purchase"
                        items={[
                          "Live inventory tracking with alerts",
                          "Seamless purchase request and vendor management",
                        ]}
                      />

                      <FeatureSection
                        title="📊 Insights & Reports"
                        items={[
                          "Real-time dashboard with sales, billing, and inventory reports",
                        ]}
                      />

                      <FeatureSection
                        title="🔧 Built-in ERP Modules"
                        items={[
                          "Point Of Sale(POS)",
                          "Inventory & Stocks Management",
                          "Purchase & Suppliers Management",
                          "Orders, Packaing, and Delivery Management",
                          "CRM, Coupons & leads Management",
                          "HRM & Payroll Management",
                          "Accounting",
                          "Reports & Analytics",
                        ]}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </section>
        <DemoButton></DemoButton>

        {/* ERP Modules Section */}
        <section className="container my-5">
          <h4 className="display-6  mb-0">
            Explore Integrated ERP Modules That Power Your Business
          </h4>

          <Row className="g-3">
            {[
              RetailPosModule,
              InventoryModule,
              PurchasesModule,
              OrdersManagementModule,
              PackagingManagementModule,
              DeliveryManagementModule,

              LeadsManagementModule,
              QuoteManagementModule,
              SalesOrderModule,
              CouponsManagementModule,
              CrmModule,

              HrmModule,
              AccountingModule,
              ReportsModule,
            ].map((Module, index) => (
              <Col md={6} lg={6} key={index}>
                <div className="bg-light p-3 rounded shadow-sm h-100 hover-shadow">
                  <Module />
                </div>
              </Col>
            ))}
          </Row>
        </section>
        <DemoButton></DemoButton>
      </>
    );
  }
}

const FeatureSection = ({ title, items }) => (
  <div className="mb-4">
    <h6 className="fw-semibold">{title}</h6>
    <ul className="mb-0 ps-3">
      {items.map((item, idx) => (
        <li key={idx}>{item}</li>
      ))}
    </ul>
  </div>
);
